module.exports = __webpack_public_path__ + "static/media/video_thumb2.709b1350.svg";